import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AuthService } from './auth.service';
import { KullaniciTipi, TEMA_ATTR, VARSAYILAN_TEMA } from '../config/tema.config';

/**
 * Kullanıcının bağlamına göre görsel temayı uygular.
 *
 * <html data-pt-tema="genel|gundem|firma"> yazar; renkleri CSS tarafı
 * assets/sass/_theme.scss içindeki [data-pt-tema] blokları belirler.
 *
 * Tema, AuthService.getKullaniciTipi() ile — yani varsayılan rotayı belirleyen
 * AYNI sınıflandırmayla — seçilir. Rol simülasyonunda currentUserValue komple
 * değiştiği için tema da simüle edilen kullanıcıya uyar; süper admin "kim olarak
 * geziyorum" sorusunu sidebar rengiyle görür.
 *
 * app.component.ts içinde başlatılır (_metronic klasörü değiştirilemediği için).
 */
@Injectable({ providedIn: 'root' })
export class TemaService implements OnDestroy {
  private readonly destroy$ = new Subject<void>();

  constructor(private readonly authService: AuthService) {}

  /**
   * Temayı uygular ve kullanıcı değiştikçe (giriş, çıkış, simülasyon başlat/bitir)
   * güncel tutar.
   */
  baslat(): void {
    this.uygula();

    this.authService.currentUserSubject
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.uygula());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /** Mevcut kullanıcı tipini <html> üzerine yazar. */
  private uygula(): void {
    document.documentElement.setAttribute(TEMA_ATTR, this.gecerliTema());
  }

  /**
   * Oturum yoksa varsayılan temaya düşer — giriş/hata sayfalarında da tutarlı
   * bir görünüm kalsın.
   */
  private gecerliTema(): KullaniciTipi {
    if (!this.authService.currentUserValue?.kisiTokenDto?.isLogin) {
      return VARSAYILAN_TEMA;
    }
    return this.authService.getKullaniciTipi();
  }
}
